// Core
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Route, Switch, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import {
  Button,
  Box,
  Flex,
  Text,
  useColorModeValue,
  useColorMode
} from '@chakra-ui/react';

// Accets
import { apiService } from 'services/ApiService';
import { getInitials, formatDateWithSuffix, validateLoadMore, parseNotifyDate } from 'services/Utils';
import { ReactComponent as TransactionIcon } from 'assets/svg/transaction-history-3.svg';
import { ReactComponent as EmptyListNotifications } from 'assets/svg/empty-list-notifications.svg';

// Components
import Card from 'components/Card/Card';
import Balance from './components/Balance';
import AffiliateCashbackTransactions from './components/AffiliateCashbackTransactions';
import WithdrawTransactions from './components/WithdrawTransactions';
import LMCTTokensTransactions from './components/LMCTTokensTransactions';
import ButtonSelector from 'components/ButtonSelector/ButtonSelector';

const Wallet = ({ userData }) => {
	const { path } = useRouteMatch();
	const [page, setPage] = useState(path);

	const { colorMode } = useColorMode();
	const isDark = colorMode === 'dark';

	const history = useHistory();
	const handlePage = (key) => {
		history.push(key); 
		setPage(key);
	};
  
	return (
		<>
			<ButtonSelector
				buttons={[
				    { key: '/account/wallet', name: 'Cashback' },
				    { key: '/account/wallet/lmctplus-tokens', name: 'LMCT+ Tokens' },
				]}
				selected={page}
				isGeneralSelected={page === '/account/wallet/affiliate' ? 0 : null}
				onSelect={handlePage}
				h="52px"
				bg={!isDark ? '#F1F4FF' : null }
			/>

			{ page !== '/account/wallet/lmctplus-tokens' && (
				<>
					<Balance userData={userData} />
					<Box mt="16px" />
					<ButtonSelector
						buttons={[
						    { key: '/account/wallet', name: 'Withdrawal' },
						    { key: '/account/wallet/affiliate', name: 'Affiliates' },
						]}
						selected={page}
						onSelect={handlePage}
						h="52px"
						w={{base: '100%', sm: '361px'}}
					/>
				</>
			)}

			<Box my="16px">
			    <Switch>
			    	<Route path="/account/wallet/affiliate" render={() => <AffiliateCashbackTransactions userData={userData} />} />
			    	<Route path="/account/wallet/lmctplus-tokens" render={() => <LMCTTokensTransactions userData={userData} />} />
				    <Route path="/account/wallet" render={() => <WithdrawTransactions userData={userData} />} />
				    <Redirect from={`${path}*`} to={`${path}`} />
				</Switch>
			</Box>
		</>
	);
};

export default Wallet;